import { api } from './client'

const kanbanService = {
  getBoards: () => api.get('/kanban/boards'),
  getLists: (boardId) => api.get(`/kanban/boards/${boardId}/lists`),
  moveTask: (data) => api.post('/kanban/tasks/move', data),
}

export default kanbanService
